import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PauseIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 4C7.44772 4 7 4.44772 7 5V19C7 19.5523 7.44772 20 8 20H9C9.55228 20 10 19.5523 10 19V5C10 4.44772 9.55228 4 9 4H8Z"
      fill="currentColor"
    />
    <path
      d="M15 4C14.4477 4 14 4.44772 14 5V19C14 19.5523 14.4477 20 15 20H16C16.5523 20 17 19.5523 17 19V5C17 4.44772 16.5523 4 16 4H15Z"
      fill="currentColor"
    />
  </svg>
);

PauseIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PauseIcon);
